module.exports = __webpack_public_path__ + "static/media/logo.8aa72c46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/logo.svg
// module id = 1396
// module chunks = 0